import { ICategory } from 'redhotpie-shared-lib/interfaces/ICommunity';
import { ILocation } from 'redhotpie-shared-lib/interfaces/IGroup';
import { utils } from '../functions';
import EventDetail from './eventDetail';
import Location from './location';
import timezone from './timezone';
import { ITimezone } from 'redhotpie-shared-lib/interfaces/ITimezone';

export interface IClubEvent {
  eventId: number;
  eventTitle: string;
  dateHeld: string;
  timezone: ITimezone | null;
  dateHeldUtcIso: Date | string;
  dateHeldDisplay: string;
  interestCount: number;
  hasExpressInterest: boolean;
  organiserType: string;
  eventBannerUrl: string;
  eventFeaturedBannerUrl: string;
  eventGlobalBannerUrl: string;
  location: ILocation | null;
  guestTypes: any[];
  categories: ICategory[];
  ageRange: any;
  organiser?: any;
  approvalStatus: string;
  isFeatured: boolean;
  isSponsored: boolean;
  isViewerOwner: boolean;
  isUserMatching?: boolean;
}

class ClubEvent {
  eventId: number;
  eventTitle: string;
  dateHeld: string;
  timezone: ITimezone | null;
  dateHeldUtcIso: Date | string;
  dateHeldUtcIsoEx: Date | string;
  dateHeldDisplay: string;
  interestCount: number;
  hasExpressInterest: boolean;
  organiserType: string;
  eventBannerUrl: string;
  eventFeaturedBannerUrl: string;
  eventGlobalBannerUrl: string;
  location: ILocation | null;
  guestTypes: any[];
  categories: ICategory[];
  ageRange: any;
  approvalStatus: string;
  isFeatured: boolean;
  isSponsored: boolean;
  isViewerOwner: boolean;
  isUserMatching: boolean;
  constructor() {
    this.eventId = 0;
    this.eventTitle = '';
    this.dateHeld = '';
    this.timezone = null;
    this.dateHeldUtcIso = '';
    this.dateHeldUtcIsoEx = '';
    this.dateHeldDisplay = '';
    this.interestCount = 0;
    this.hasExpressInterest = false;
    this.organiserType = 'All';
    this.eventBannerUrl = '';
    this.eventFeaturedBannerUrl = '';
    this.eventGlobalBannerUrl = '';
    this.location = null;
    this.guestTypes = [];
    this.categories = [];
    this.ageRange = null;
    this.approvalStatus = '';
    this.isFeatured = false;
    this.isSponsored = false;
    this.isViewerOwner = false;
    this.isUserMatching = false;
  }

  static mappingObject(_obj: any) {
    const obj = new ClubEvent();
    obj.eventId = _obj.EventID || 0;
    obj.eventTitle = _obj.Title || _obj.EventTitle || '';
    obj.approvalStatus = _obj.ApprovalStatus || '';
    obj.dateHeld = _obj.DateHeld || '';
    obj.timezone = _obj.TimeZone ? timezone.mappingObject(_obj.TimeZone) : null;
    obj.dateHeldUtcIso = _obj.DateHeldUtcIso
      ? utils.formatDateTimeWithTimezone(
          _obj.DateHeldUtcIso,
          obj.timezone && utils.hasOwnProperty(obj.timezone, 'ianaName') ? obj.timezone.ianaName : ''
        )
      : '';
    obj.dateHeldUtcIsoEx = _obj.DateHeldUtcIso;
    obj.dateHeldDisplay = _obj.DateHeldDisplay || '';
    obj.interestCount = _obj.InterestCount || 0;
    obj.hasExpressInterest = _obj.HasExpressInterest || false;
    obj.organiserType = _obj.OrganiserType || 'All';
    obj.eventBannerUrl = _obj.EventBannerUrl || '';
    obj.eventFeaturedBannerUrl = _obj.EventFeaturedBannerUrl || '';
    obj.eventGlobalBannerUrl = _obj.EventFeaturedBannerUrl || '';
    obj.location = (_obj.Location && Location.mappingObject(_obj.Location)) || undefined;
    obj.guestTypes = _obj.GuestTypes ? _obj.GuestTypes.map((item: any) => EventDetail.mappingPropertyObject(item)) : [];
    obj.categories = _obj.Categories ? _obj.Categories.map((item: any) => EventDetail.mappingPropertyObject(item)) : [];
    obj.ageRange = _obj.AgeRange ? { ageMin: _obj.AgeRange.AgeFrom || -1, ageMax: _obj.AgeRange.AgeTo || -1 } : null;
    obj.isFeatured = _obj.IsFeatured || false;
    obj.isSponsored = _obj.IsSponsored || false;
    obj.isViewerOwner = _obj.IsViewerOwner || false;
    obj.isUserMatching = _obj.IsUserMatching || false;

    return obj;
  }
}

export default class ClubEvents {
  data: IClubEvent[];
  total: number;

  constructor() {
    this.data = [];
    this.total = 0;
  }

  static mappingObject(_obj: any) {
    const obj = new ClubEvents();
    obj.data = _obj.Data
      ? _obj.Data.map((obj: any) => {
          return ClubEvent.mappingObject(obj);
        })
      : [];
    obj.total = _obj.Total || 0;

    return obj;
  }
}
